import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { useSelector } from 'react-redux';
import Button from '../../elements/Button';
import TextField from '../../fields/Text';
import styles from './styles.scoped.css';

export default function ForgotPassword({
  handleSubmit = () => {},
  invalid = true,
  submitSucceeded = false,
}) {
  const { isLoading, message } = useSelector((s) => s.forgotPassword);
  const btnDisabled = invalid || isLoading;
  const inputProps = {
    placeholder: 'Masukkan Email',
  };

  return (
    <form className={styles.root} onSubmit={handleSubmit}>
      <label>Email</label>
      <Field
        component={TextField}
        hideLabel={true}
        inputProps={inputProps}
        name="email"
      />
      {message !== 'SUKSES' && submitSucceeded && (
        <p className={styles.error}>{message}</p>
      )}
      <Button disabled={btnDisabled} type="submit">
        {isLoading ? 'Mengirim...' : 'Kirim Link Reset Password'}
      </Button>
    </form>
  );
}

ForgotPassword.propTypes = {
  handleSubmit: PropTypes.func,
  invalid: PropTypes.bool,
  submitSucceeded: PropTypes.bool,
};
